import {useState} from 'react'
import {getFetcher, getFetcherWithResponse} from '@startlibs/utils'
import {useEffect, useMemo} from 'react'
import {usePrevious} from '@startlibs/core'
import {authGetFetcher, urlTokenGetFetcher} from '../utils/authFetch'

export const SuspenseError = function(el) { this.get = () => el}

export const willUseSuspense = (loadResource) => {

  const cache = new Map()
  const promiseCache = new Map()

  function read(key ) {
    if (cache.has(key)) {
      const cached = cache.get(key)
      if (cached instanceof SuspenseError) {
        throw cached
      } else {
        return cached
      }
    }
    if (promiseCache.has(key)) {
      throw promiseCache.get(key)
    }
    const suspender = loadResource(key)
    promiseCache.set(key,suspender)
    throw suspender.then(thing => {
      cache.set(key,thing)
      promiseCache.delete(key)
      return thing
    }).catch(e => {
      promiseCache.delete(key)
      cache.set(key, new SuspenseError(e))
    })
  }

  const remove = (key) => {
    cache.delete(key)
  }

  return (key) => {
    useEffect(() => () => remove(key),[key])
    return useMemo(() => read(key),[key])
  }
}

export const useSuspense = willUseSuspense(getFetcher)
export const useTokenSuspense = willUseSuspense(urlTokenGetFetcher)
export const useAuthSuspense = willUseSuspense(authGetFetcher)